const round = (num) => {
  const m = Number((Math.abs(num) * 100).toPrecision(15));
  // eslint-disable-next-line no-mixed-operators
  return Math.round(m) / 100 * Math.sign(num);
};

export {
  round,
};
